import { useContext, useMemo } from 'react';
import { useRecoilValue } from 'recoil';
import { blockCustomSliceRange, blockExpandedState } from 'venn-state';
import { BlockContext } from '../../contexts/block-context';

export const useCustomSlice = <T>(items: T[], blockId: string): T[] => {
  const isExpanded = useRecoilValue(blockExpandedState(blockId));
  const sliceRange = useRecoilValue(blockCustomSliceRange(blockId));
  const blockContext = useContext(BlockContext);
  const isContinuation = blockContext?.isContinuation;
  const continuationIndex = blockContext?.continuationIndex;

  return useMemo(() => {
    if (!isExpanded) return items;
    const { sourceRowCount, continuationRowCount } = sliceRange;
    if (sourceRowCount === 0) return items;
    if (isContinuation && continuationIndex !== undefined) {
      const start = sourceRowCount + continuationIndex * continuationRowCount;
      const end = Math.min(items.length, start + continuationRowCount);
      return items.slice(start, end);
    }
    return items.slice(0, sourceRowCount);
  }, [isExpanded, sliceRange, isContinuation, continuationIndex, items]);
};
